module.exports = __webpack_public_path__ + "static/media/logic.5f1b4dd3.png";